































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import { PulldownItem } from "@/types";
import Cookies from "js-cookie";

//事業所選択エリア
export interface OfficeSelectItem extends PulldownItem {
  unique_id: number;
}

@Component
export default class OfficeSelect extends mixins(AxiosMixin) {
  private selectId = 0;
  private offices: OfficeSelectItem[] = [];

  created() {
    this.postJsonCheck(window.base_url + "/api/ibow_office/get", {}, res => {
      this.offices = res.data.office;
    });
  }

  get selectItem(): OfficeSelectItem | undefined {
    return this.offices.find(v => {
      if (v.value == this.selectId) {
        return true;
      } else {
        return false;
      }
    });
  }

  private clickSelect() {
    this.postJsonCheck(
      window.base_url + "/api/auth/add_office",
      {
        office_ibow_id: this.selectItem?.value,
        office_ibow_unique_id: this.selectItem?.unique_id
      },
      res => {
        window.token = res.data.token;
        Cookies.set("token", window.token);
        window.reftoken = res.data.ref_token;
        Cookies.set("reftoken", window.reftoken);
        if (this.selectItem) {
          window.office_name = this.selectItem.text;
          Cookies.set("office_name", window.office_name);
        }
        this.select();
      }
    );
  }

  @Emit()
  private select() {
    return;
  }
}
